import React, { useState } from "react";
import "../styles/TablesShelppanel.css";
import { useGame } from "../GameContext";

type HelppanelProps = {
  type: number;
};

const Helppanel: React.FC<HelppanelProps> = ({ type }) => {
  const { isHelpPanelOpen, setHelpPanelOpen } = useGame();
  const [showhelpPivots, setShowhelpPivots] = useState<string>("pivotTask");

  if (!isHelpPanelOpen) {
    return null;
  }

  return (
    <div className="tableS-helpPanel" id="tableS-helpPanel">
      <img
        src="/img/close.svg"
        id="hotel-closeButton"
        alt="Закрыть"
        className="tableS-closeButton"
        onClick={() => setHelpPanelOpen(false)}
      />
      <div className="tableS-helpPivots">
        <div
          className="tableS-selectPivots"
          id={showhelpPivots === "pivotTask" ? "tableS-activePivot" : ""}
          onClick={() => setShowhelpPivots("pivotTask")}
        >
          Задача
        </div>
      </div>
      {showhelpPivots === "pivotTask" && (
        <div id="tableS-commandsCards">
          <div className="tableS-helpCard">
            <div className="tableS-cardCaption">Суть игры</div>
            
              {(() => {
                switch (type) {
                  case 1:
                    // Здесь можно добавить текст для типа 1
                    return <div>Content for type1</div>;
                  case 2:
                    // Здесь можно добавить текст для типа 2
                    return <div>Content for type2</div>;
                  case 3:
                    // Здесь можно добавить текст для типа 3
                    return <div>Default content</div>;
                }
              })()}
            
          </div>
          <div className="tableS-helpCard">
            <div className="tableS-cardCaption">Правила игры</div>
             {(() => {
                switch (type) {
                  case 1:
                    // Здесь можно добавить текст для типа 1
                    return <div>Content for type1</div>;
                  case 2:
                    // Здесь можно добавить текст для типа 2
                    return <div>Content for type2</div>;
                  case 3:
                    // Здесь можно добавить текст для типа 3
                    return <div>Default content</div>;
                }
              })()}
          </div>
        </div>
      )}
    </div>
  );
};
export default Helppanel;
